import React from "react";
import moment from "moment";

import { isAppleDevice, isWeb } from "../../../helpers/utils";

import AlmostThereCard from "../home/cards/AlmostThereCard";
import CoachReviewCard from "../home/cards/CoachReviewCard";
//import AutoTrackCard from "../home/cards/AutoTrackCard";
import GoalAchievedCard from "../home/cards/GoalAchievedCard";
import ImpersonateCard from "../home/cards/ImpersonateCard";
import ReflectionCard from "../home/cards/ReflectionCard";
import NewReportsCard from "../home/cards/NewReportsCard";
import NewReportsCommentsCard from "../home/cards/NewReportsCommentsCard";
import ManaScoreCard from "../home/cards/ManaScoreCard";
import IntegrationMappingCard from "../home/cards/integration/IntegrationMappingCard";
import ScheduleTimeCard from "../home/cards/ScheduleTimeCard";
import SetupChecklistCard from "../home/cards/onboarding/SetupChecklistCard";
import GoalsPresetsCard from "../home/cards/onboarding/GoalsPresetsCard";
import SubmitReportsCard from "../home/cards/SubmitReportsCard";
import GoalPreviewCard from "../home/cards/GoalPreviewCard";
//import StatsCard from "../home/cards/StatsCard";
import ComparisonCard from "../home/cards/reflection/ComparisonCard";
import TimerCard from "../home/cards/timer/TimerCard";

// Integrations
import CalendarIntegrationCard from "../home/cards/integration/setup/CalendarIntegrationCard";
import HealthIntegrationCard from "../home/cards/integration/setup/HealthIntegrationCard";
import ChromeIntegrationCard from "../home/cards/integration/setup/ChromeIntegrationCard";
import SlackReconnectCard from "../home/cards/integration/reconnect/SlackReconnectCard";
import GCalendarReconnectCard from "../home/cards/integration/reconnect/GCalendarReconnectCard";
import HealthReconnectCard from "../home/cards/integration/reconnect/HealthReconnectCard";
import DesktopReconnectCard from "../home/cards/integration/reconnect/DesktopReconnectCard";
import DesktopIntegrationCard from "../home/cards/integration/setup/DesktopIntegrationCard";
import ChromeReconnectCard from "../home/cards/integration/reconnect/ChromeReconnectCard";
import CalendarReconnectCard from "../home/cards/integration/reconnect/CalendarReconnectCard";

const IntegrationCardsConfig = {
  calendar: {
    connect: CalendarIntegrationCard,
    reconnect: isWeb
      ? GCalendarReconnectCard
      : [GCalendarReconnectCard, CalendarReconnectCard],
  },
  health: isAppleDevice
    ? { connect: HealthIntegrationCard, reconnect: HealthReconnectCard }
    : { connect: null, reconnect: null },
  desktop: { connect: DesktopIntegrationCard, reconnect: DesktopReconnectCard },
  chrome: { connect: ChromeIntegrationCard, reconnect: ChromeReconnectCard },
  slack: { connect: null, reconnect: SlackReconnectCard },
};

export const CardsConfig = {
  impersonate: ImpersonateCard,
  onboarding_progress: SetupChecklistCard,
  goal_achieved: GoalAchievedCard,
  almost_there: AlmostThereCard,
  coach_review: CoachReviewCard,
  reflection: ReflectionCard,
  new_reports: NewReportsCard,
  new_report_comments: NewReportsCommentsCard,
  submit_reports: SubmitReportsCard,
  mana_score: ManaScoreCard,
  integrations_mapping: IntegrationMappingCard,
  schedule_time: ScheduleTimeCard,
  onboarding_goals: GoalsPresetsCard,
  goal_preview: GoalPreviewCard,
  comparison_card: ComparisonCard,
  //timer_card: TimerCard, uncomment after removing from HomePage
  //stats_card: StatsCard,
  //autoreview: AutoTrackCard,
};

// ------------------------------------- PUBLIC -------------------------------------
export const buildCards = (controller, cardItems, cardsV2, args) => {
  let allCards = {};
  // There can be more cards of the same type
  cardItems.forEach((c) => {
    if (allCards[c.type]) {
      allCards[c.type].push(c);
    } else {
      allCards[c.type] = [c];
    }
  });

  const Cards_Config = args.allowedCardsList || CardsConfig;

  Object.keys(Cards_Config).forEach((cardKey) => {
    let clist = allCards[cardKey];
    if (clist)
      clist.forEach((c) => {
        if (c) {
          let CardType = Cards_Config[cardKey];

          cardsV2.push(
            <CardType
              controller={controller}
              data={c}
              key={c.card_id || c.type}
              {...args}
            />,
          );
        }
      });
  });
};

const addReconnectCard = (controller, cardsV2, integrationType) => {
  const prefs = controller.state?.settings?.testing_preferences || {};
  const prefKey = `show_${integrationType}_integration_card`;

  const isTestingReconnect = prefs["show_integrations_reconnect_card"];
  const isTestingIntCard = prefs[prefKey];

  const devices = controller.getDevices(integrationType);
  let device = {};

  const showConnect = !(devices && devices.length > 0);
  let showReconnect = !showConnect;
  if (showReconnect) {
    showReconnect = false;
    devices.forEach((d) => {
      let needsReconnect = false;
      if (d.isEnabled) {
        if (!d.isConnected || d.last_updated == null) {
          needsReconnect = true;
          console.log("Reconnect " + integrationType + ", not updated");
          device = d;
        } else {
          const now = moment().tz("UTC");
          const updateTime = moment.utc(d.last_updated);
          const duration = now.diff(updateTime, "hours");
          const TOO_OLD_HOURS = 24 * 3;
          if (duration > TOO_OLD_HOURS) {
            console.log("Reconnect " + integrationType + ", old update");
            needsReconnect = true;
            device = d;
          }
        }
        if (needsReconnect) showReconnect = true;
      }
    });
  }

  const cardData = IntegrationCardsConfig[integrationType];
  if (!cardData) return;

  const Cards =
    isTestingIntCard || showConnect
      ? cardData.connect
      : isTestingReconnect || showReconnect
      ? cardData.reconnect
      : null;

  if (!Cards) return;

  const CardsList = Array.isArray(Cards) ? Cards : [Cards];

  CardsList.forEach((CardType) => {
    cardsV2.push(
      <CardType
        controller={controller}
        device={device}
        key={`${integrationType}${showConnect ? "Sync" : "Reconnect"}Card`}
      />,
    );
  });
};

const addReconnectCards = (controller, cardsV2) => {
  ["calendar", "health", "chrome", "slack"].forEach((cardName) =>
    addReconnectCard(controller, cardsV2, cardName),
  );
};

export default {
  buildCards,
  addReconnectCards,
  addReconnectCard,
};
